import { Component, Inject, Input, OnChanges, ViewChild } from '@angular/core';
import { Headers, Http, URLSearchParams } from '@angular/http';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { closeDialog, openDialog } from '../common/dialogs/dialogs.actions';
import { Config } from '../universal-config';
import { ShareCopyService } from './share-copy.service';
import { deleteShare, setShareAccess } from './share.actions';

export enum SHARE_ACCESS_TYPES {
  PUBLIC = 'public',
  PRIVATE = 'workspace',
}

@Component({
  selector: 'nns-share-config',
  template: `
    <div class="share-config-body">
      <div class="share-config-container">
        <div class="share-config-title">Manage public page</div>
      </div>
      <div class="share-config-container">
        <nns-workspace-select
          *ngIf="workspaces && workspaces.length && currentNoteWorkspace && !isNoteMoving"
          [workspaces]="workspaces"
          [selectedWorkspace]="currentNoteWorkspace"
          [ownerId]="profile ? profile.userId : null"
          (onSelectWorkspaceEvent)="onSelectWorkspace($event)"
        ></nns-workspace-select>
        <div *ngIf="!workspaces || !workspaces.length || !currentNoteWorkspace || isNoteMoving" style="height: 53px;" class="nns-spinner-wrapper">
          <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
        </div>
      </div>
      <div class="share-config-container">
        <div layout="row" layout-align="start center">
          <div class="share-config-container-title" flex>Private</div>
          <div *ngIf="!isAccessPending">
            <mat-slide-toggle disableRipple [checked]="isAccessPrivate" (change)="toggleAccess()"></mat-slide-toggle>
          </div>
          <div *ngIf="isAccessPending" style="height: 24px">
            <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
          </div>
        </div>
        <div *ngIf="!isAccessPrivate" class="share-config-container-subtitle">Available to everyone with the link</div>
        <div *ngIf="isAccessPrivate" class="share-config-container-subtitle">Only workspace members have access</div>
      </div>
      <div class="share-config-container">
        <input
          *ngIf="shortUrl"
          #shortUrlInput
          readonly
          class="share-config-input m-short-url"
          [value]="shortUrl"
          (click)="selectShortUrl($event)"
          >
          <div style="height: 32px;" *ngIf="!shortUrl">
            <mat-progress-spinner style="margin-left: auto; margin-right: auto;" mode="indeterminate" diameter="24"></mat-progress-spinner>
          </div>
      </div>
      <div class="share-config-container">
        <button class="share-config-button" (click)="copyShortUrl($event)">
          <span *ngIf="!isShortUrlCopied">Copy</span>
          <span *ngIf="isShortUrlCopied">Copied!</span>
        </button>
      </div>
      <div class="share-config-container" layout="row" layout-align="start center">
        <div class="share-config-container-title" flex>Password</div>
        <div *ngIf="!isPasswordPending" class="nns-slide-wrapper">
          <mat-slide-toggle disableRipple [checked]="isPasswordEnabled"></mat-slide-toggle>
          <div class="nns-slide-wrapper-overlay" (click)="togglePassword()"></div>
        </div>
        <div *ngIf="isPasswordPending" style="height: 24px">
          <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
        </div>
      </div>
      <div class="share-config-container" *ngIf="isPasswordEnabled">
        <input
          #passwordInput
          [type]="passwordType"
          placeholder="*******"
          class="share-config-input share-config-input__password"
          [(ngModel)]="passwordDraft"
          >
        <div class="share-config-show-password" *ngIf="passwordDraft.length" (click)="onChangePasswordType()">
          <nns-icon icon="eye" *ngIf="passwordType === 'text'"></nns-icon>
          <nns-icon icon="eye-closed" *ngIf="passwordType === 'password'"></nns-icon>
        </div>
      </div>
      <div class="share-config-container" *ngIf="isPasswordEnabled">
        <button class="share-config-button" (click)="savePassword()" [disabled]="!passwordDraft || isPasswordPending">
          <span *ngIf="!isPasswordRequired">Set pass</span>
          <span *ngIf="isPasswordRequired">Change pass</span>
        </button>
      </div>
    </div>
    <div class="share-config-footer">
      <div class="share-config-actions" layout="row" layout-align="start center">
        <div class="share-config-action">
          <a class="nns-href" *ngIf="!isDeletePending" (click)="onDeleteShare()">
            <div class="share-config-action-icon">
              <nns-icon icon="delete"></nns-icon>
            </div>
            <div class="share-config-action-icon_hover">
              <nns-icon icon="delete-hover"></nns-icon>
            </div>
            <span class="share-config-action-text">Remove shared link</span>
          </a>
          <mat-progress-spinner *ngIf="isDeletePending" mode="indeterminate" diameter="16"></mat-progress-spinner>
        </div>
        <div class="share-config-action">
          <a class="nns-href" target="_blank" [href]="noteUrl" (click)="onAttachClick()">
            <div class="share-config-action-icon">
              <nns-icon icon="attach"></nns-icon>
            </div>
            <div class="share-config-action-icon_hover">
              <nns-icon icon="attach-hover"></nns-icon>
            </div>
            <span class="share-config-action-text">
              <span>Attach/Embed anything</span>
              <span class="share-config-action-text_secondary" *ngIf="isAttachBtnActive">Refresh page to see attached files</span>
            </span>
          </a>
        </div>
        <div class="share-config-action" *ngIf="false" (click)="onDeleteShare()" title="Delete public page">
          <div *ngIf="!isDeletePending">
            <div class="share-config-action-icon">
              <nns-icon icon="delete"></nns-icon>
            </div>
            <div class="share-config-action-icon_hover">
              <nns-icon icon="delete-hover"></nns-icon>
            </div>
          </div>
          <mat-progress-spinner *ngIf="isDeletePending" mode="indeterminate" diameter="16"></mat-progress-spinner>
        </div>
      </div>
      <div class="share-config-owner" *ngIf="false" layout="row" layout-align="start center">
        <div class="share-config-owner-avatar">
          <span *ngIf="!owner.avatarUrl">{{ owner.displayName[0] }}</span>
          <img *ngIf="owner.avatarUrl" [src]="owner.avatarUrl">
        </div>
        <div class="share-config-owner-content">
          <div class="share-config-owner-title">{{ owner.displayName }}</div>
          <div class="share-config-owner-description">{{ createdDate | date:'MMMM d, y' }}</div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .share-config-container{
      position: relative;
    }
    .share-config-container + .share-config-container {
      margin-top: 15px;
    }
    .share-config-container-title {
      font-size: 13px;
    }
    .share-config-container-subtitle {
      font-size: 10px;
      opacity: .6;
    }
    .share-config-body {
      border-width: 1px;
      border-style: solid;
      padding: 20px;
    }
    .share-config-footer {
      padding: 15px 0;
    }
    .share-config-title {
      font-size: 16px;
      font-weight: 700;
      line-height: 22px;
      text-align: center;
    }
    .share-config-button {
      box-sizing: border-box;
      display: inline-block;
      width: 100%;
      height: 32px;
      padding: 5px 15px;
      border-radius: 16px;
      border: 1px solid #00A1B7;
      color: #00A1B7;
      font-size: 13px;
      font-weight: 700;
      text-align: center;
      line-height: 18px;
      background: rgba(0,0,0,0);
      transition: .3s;
    }
    .share-config-button[disabled] {
      opacity: .5;
      cursor: not-allowed;
    }
    .share-config-input {
      box-sizing: border-box;
      display: inline-block;
      width: 100%;
      height: 32px;
      padding: 7px 15px;
      border-width: 1px;
      border-style: solid;
      border-radius: 2px;
      font-size: 12px;
      text-align: center;
      line-height: 16px;
      background: rgba(0,0,0,0);
    }
    .share-config-input__password{
      padding-right: 32px;
    }
    .share-config-actions{
      flex-direction: column;
    }
    .share-config-actions .nns-href{
      display: flex;
      align-items: center;
      color: #161616;
    }
    .share-config-actions .nns-href nns-icon{
      min-width: 30px;
      min-height: 30px;
      margin-right: 8px;
    }
    .share-config-action {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      height: 30px;
      margin-right: 10px;
      padding: 7px 8px;
      transition: .3s;
      cursor: pointer;
    }
    .share-config-action-text{
      display: flex;
      flex-direction: column;
      font-size: 13px;
    }
    .share-config-action:not(:last-child) {
      margin-bottom: 15px;
    }
    .share-config-action-text_secondary{
      color: #00A1B7;
      font-size: 10px;
    }
    .share-config-action nns-icon {
      min-width: 16px;
      min-height: 16px;
    }
    .share-config-action-icon_hover{
      display: none;
    }
    .share-config-action:hover .share-config-action-icon{
      display: none;
    }
    .share-config-action:hover .share-config-action-icon_hover{
      display: block;
    }
    .share-config-owner-avatar {
      width: 26px;
      height: 26px;
      border-radius: 50%;
      overflow: hidden;
      background: rgb(200, 200, 200);
    }
    .share-config-owner-avatar img {
      width: 100%;
      height: 100%;
    }
    .share-config-owner-avatar span {
      display: block;
      width: 100%;
      height: 100%;
      text-align: center;
      font-size: 14px;
      font-weight: 700;
      line-height: 26px;
      color: #FFF;
    }
    .share-config-owner-content {
      padding-left: 8px;
    }
    .share-config-owner-title {
      font-size: 12px;
      font-weight: 700;
      line-height: 16px;
    }
    .share-config-owner-description {
      font-size: 10px;
      font-weight: 400;
      line-height: 14px;
    }
    .nns-spinner-wrapper{
      display: flex;
      align-items: center;
      justify-content: center;
    }
    nns-workspace-select{
      position: relative;
      display: block;
      z-index: 2;
    }
    .nns-slide-wrapper{
      position: relative;
    }
    .nns-slide-wrapper-overlay{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
      z-index: 1;
    }
    .share-config-show-password{
      position: absolute;
      top: 0;
      right: 5px;
      cursor: pointer;
      height: 100%;
      display: flex;
      align-items: center;
    }

    .share-config-show-password nns-icon{
      min-width: 16px;
      min-height: 16px;
    }

    :host nns-workspace-select ::ng-deep .nns-select-item{
      padding-right: 4px;
    }

    :host-context(.nns-theme-day) .share-config-body { border-color: #DCDCDC; }
    :host-context(.nns-theme-day) .share-config-input { border-color: #DCDCDC; color: rgba(0, 0, 0, .6); }
    :host-context(.nns-theme-day) .share-config-owner-title { color: #161616; }
    :host-context(.nns-theme-day) .share-config-owner-description { color: rgba(0, 0, 0, .6); }

    :host-context(.nns-theme-night) .share-config-body { border-color: rgba(255,255,255,0.12); }
    :host-context(.nns-theme-night) .share-config-input { border-color: rgba(255,255,255,0.12); color: rgba(255, 255, 255, .6); }
    :host-context(.nns-theme-night) .share-config-owner-title { color: #FFF; }
    :host-context(.nns-theme-night) .share-config-owner-description { color: rgba(255, 255, 255, .6); }
    :host-context(.nns-theme-night) .share-config-actions .nns-href{
      color: #fff;
    }
  `]
})
export class ShareConfigComponent implements OnChanges {
  @Input() share;
  @Input() note;
  @Input() workspaces;
  @Input() currentNoteWorkspace;
  @Input() visual;
  @Input() profile;
  @ViewChild('shortUrlInput') shortUrlInput;
  @ViewChild('passwordInput') passwordInput;

  shortUrl: string;
  fullUrl: string;
  createdDate: number;
  isShortUrlCopied: boolean;
  isPasswordEnabled: boolean;
  isPasswordRequired: boolean;
  isPasswordPending: boolean;
  isAccessPrivate: boolean;
  isAccessPending: boolean;
  isDeletePending: boolean;
  passwordDraft = '';
  passwordType: 'text' | 'password' = 'password';
  owner: {
    displayName: string;
    avatarUrl: string;
  };
  workspace: {
    title: string,
    color: string,
    titleChar: string,
    members: number,
  };
  isNoteMoving: boolean;
  isAttachBtnActive: boolean;

  nimbusNoteUrl;
  authDomain;
  nimbusUrl;
  noteUrl;

  constructor(
    public _http: Http,
    public _config: Config,
    public _store: Store<IAppState>,
    @Inject('isBrowser') public isBrowser: boolean,
    public _shareCopyService: ShareCopyService,
  ) {
    this.nimbusNoteUrl = this._config.get('NIMBUS_NOTE_URL');
    this.authDomain = this._config.get('AUTH_HOST');
    this.nimbusUrl = this._config.get('NIMBUS_URL');
  }

  ngOnChanges(changes) {
    this.isAccessPrivate = this.share.instance.accessControl == SHARE_ACCESS_TYPES.PRIVATE ? true : false;
    this.isAccessPending = this.visual.isShareAccessUpdating;
    this.isPasswordPending = this.visual.isSharePasswordUpdating;
    this.owner = this.share.instance.owner;
    this.workspace = this.share.instance.workspace;
    this.workspace.titleChar = this.workspace.title.substr(0, 1);

    if(this.isBrowser && changes.share && changes.share.currentValue != changes.share.previousValue) {
      const shareId = this.share.instance.id;
      const securityKey = this.share.instance.securityKey;
      this.fullUrl = `${window.location.origin}/share/${shareId}/${securityKey}`;
      this.fetchShortUrl();
    }

    if(changes.share) {
      this.isPasswordEnabled = this.share.instance.passwordRequired;
      this.isPasswordRequired = this.share.instance.passwordRequired;
      this.isNoteMoving = this.share.isNoteMoving;
    }

    this.createdDate = this.note.createdAt * 1000;

    if(changes.note || changes.share) {
      if(this.note && this.share && this.share.instance) {
        this.setNoteUrl();
      }
    }
  }

  fetchShortUrl() {
    const params = new URLSearchParams();
    params.append('url', this.fullUrl);
    const domain = this.share.instance.org && this.share.instance.org.domain ? this.share.instance.org.domain : null
    if (domain) {
      params.append('domain', domain);
    } else if (this.share.instance.org && this.share.instance.org.shortDomain) {
      params.append('short_domain', this.share.instance.org.shortDomain);
    }
    const headers = new Headers({
      'Accept': '*/*',
      'Content-Type': 'application/x-www-form-urlencoded'
    })
    this._http.post(this._config.get('SHORT_URL_SERVICE'), params.toString(), {
      headers
    }).toPromise()
      .then((response) => {
        const result = response.json();
        if (result && result.short_url) {
          this.shortUrl = result.short_url;
        } else {
          this.shortUrl = 'http://nimb.ws/nrBC17';
        }
      }).catch((err) => {
        this.shortUrl = 'http://nimb.ws/nrBC17';
    });
  }

  selectShortUrl(event) {
    event.target.setSelectionRange(0, this.shortUrl.length);
  }

  copyShortUrl(event) {
    if (this.isShortUrlCopied || !this.shortUrl) { return; }
    event.preventDefault();
    event.stopPropagation();
    this.shortUrlInput.nativeElement.focus();
    this.shortUrlInput.nativeElement.setSelectionRange(0, this.shortUrl.length);
    document.execCommand('copy');
    this.isShortUrlCopied = true;
    setTimeout(() => {
      this.isShortUrlCopied = false;
    }, 2000);
  }

  togglePassword() {
    const isStarter = this.getIsCurrentWorkspaceFree();
    if(!this.isPasswordEnabled && isStarter) {
      this.showPasswordPopup()
      return
    }

    this.isPasswordEnabled = !this.isPasswordEnabled;
    this.passwordDraft = '';
    if(this.isPasswordEnabled) {
      setTimeout(() => {
        this.passwordInput.nativeElement.focus();
      })
    } else {
      this.savePassword();
    }
  }

  showPasswordPopup() {
    const isOwner = this.currentNoteWorkspace.userId === this.profile.userId
    const isStarter = this.getIsCurrentWorkspaceFree();
    const dialogOptions = {
      text: isOwner
        ? 'The password for public pages and folders is included in the premium plan. Upgrade to FuseBase Standard to continue.'
        : 'The password for public pages and folders is included in the premium plan. Contact the workspace owner for more details.',
      okButtonText: isOwner ? 'Go to FuseBase' : 'Ok',
      hideCancelButton: !isOwner,
      onSuccess: () => {
        if(isOwner) {
          window.open('https://nimbusweb.me/pricing.php?public_page_banner=set_page_password');
        }
        this._store.dispatch(closeDialog());
      }
    }
    this._store.dispatch(openDialog(dialogOptions));
  }

  savePassword() {
    const updatedPassword = this.passwordDraft;
    if(updatedPassword) {
      this._store.dispatch(setShareAccess({password: updatedPassword}));
    } else if(this.share.instance.passwordRequired){
      this._store.dispatch(setShareAccess({password: ''}));
    }
  }

  getIsCurrentWorkspaceFree() {
    return !this.currentNoteWorkspace.hasActivePremium;
  }

  toggleAccess() {
    if(this.isAccessPrivate) {
      this._store.dispatch(setShareAccess({accessControl: SHARE_ACCESS_TYPES.PUBLIC}));
    } else {
      this._store.dispatch(setShareAccess({accessControl: SHARE_ACCESS_TYPES.PRIVATE}));
    }
  }

  onSelectWorkspace(workspaceId) {
    const currentWorkspaceId = this.note.workspaceId;
    const workspaceIdToMove = workspaceId;
    this._shareCopyService.move(this.note.globalId, currentWorkspaceId, workspaceIdToMove);
  }

  onDeleteShare() {
    const dialogOptions = {
      title: 'Remove shared link',
      text: 'Are you sure you want to remove the shared link?',
      okButtonText: 'Yes, delete',
      onSuccess: () => {
        this._store.dispatch(closeDialog());
        this._store.dispatch(deleteShare());
        this.isDeletePending = true;
      }
    }
    this._store.dispatch(openDialog(dialogOptions));
  }

  setNoteUrl() {
    const nimbusUrl = this.getNimbusUrl();
    if(this.note && this.note.workspaceId && this.note.type) {
      this.noteUrl = `${nimbusUrl}/ws/${this.note.workspaceId}/${this.note.type}/${this.note.globalId}`;
    }
  }

  getNimbusUrl() {
    if(this.share.instance.org) {
      if(this.share.instance.org.domain) {
        return `http://${this.share.instance.org.domain}`;
      } else {
        return `http://${this.share.instance.org.sub}.${this._config.get('NIMBUS_DOMAIN')}`;
      }
    } else {
      return this.nimbusUrl;
    }
  }

  onAttachClick() {
    this.isAttachBtnActive = true;
  }

  onChangePasswordType() {
    this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
  }
}
